{
  "app": {
    "name": "VECOS Admin",
    "skipToContent": "Skip to content"
  },
  "nav": {
    "overview": "Overview",
    "people": "People",
    "worlds": "Worlds",
    "assets": "Assets",
    "avatars": "Avatars",
    "groups": "Groups & permissions",
    "flags": "Feature flags",
    "parameters": "Limits",
    "moderation": "Moderation",
    "system": "System",
    "audit": "Audit log",
    "sectionPlatform": "Platform",
    "sectionContent": "Content",
    "sectionAccess": "Access",
    "sectionOperations": "Operations",
    "openMenu": "Open the menu",
    "categories": "World categories",
    "site": "Marketing site",
    "legal": "Legal",
    "analytics": "Analytics",
    "releases": "App releases"
  },
  "auth": {
    "title": "VECOS Admin",
    "subtitle": "Sign in to manage the platform.",
    "email": "Email",
    "password": "Password",
    "signIn": "Sign in",
    "signingIn": "Signing in…",
    "signOut": "Sign out",
    "notAdmin": "This account cannot use the admin panel.",
    "invalid": "That email and password do not match.",
    "rateLimited": "Too many attempts. Wait a moment and try again.",
    "emailRequired": "Enter your email address.",
    "emailInvalid": "That does not look like an email address.",
    "passwordRequired": "Enter your password.",
    "unavailable": "The server is not responding. Try again in a moment."
  },
  "theme": {
    "toggle": "Switch theme",
    "light": "Light",
    "dark": "Dark",
    "system": "Match system"
  },
  "language": {
    "label": "Language",
    "switchTo": "Switch to {{language}}"
  },
  "common": {
    "cancel": "Cancel",
    "close": "Close",
    "save": "Save",
    "create": "Create",
    "edit": "Edit",
    "delete": "Delete",
    "remove": "Remove",
    "retry": "Try again",
    "loadMore": "Load more",
    "loading": "Loading…",
    "all": "All",
    "none": "None",
    "yes": "Yes",
    "no": "No",
    "actions": "Actions",
    "copied": "Copied",
    "copyId": "Copy id",
    "notSet": "—",
    "never": "Never",
    "unknown": "Unknown",
    "showing_one": "Showing {{count}} of {{total}}",
    "showing_other": "Showing {{count}} of {{total}}",
    "requiredField": "This field is required.",
    "sortBy": "Sort by",
    "moreActions": "More actions",
    "add": "Add",
    "openInNewTab": "Open in a new tab",
    "reset": "Reset"
  },
  "state": {
    "emptyTitle": "Nothing here yet",
    "emptyFiltered": "Nothing matches those filters",
    "emptyFilteredHint": "Try widening the search or clearing a filter.",
    "errorTitle": "Something went wrong",
    "errorHint": "The server refused that request.",
    "offlineTitle": "Cannot reach the server",
    "offlineHint": "Check that the backend is running, then try again.",
    "forbiddenTitle": "You do not have permission",
    "forbiddenHint": "This account is missing the permission this page needs.",
    "notFoundTitle": "Not found",
    "notFoundHint": "That page does not exist, or it moved.",
    "goHome": "Back to the overview"
  },
  "overview": {
    "title": "Overview",
    "subtitle": "The platform at a glance.",
    "people": "People",
    "peopleTotal": "Accounts",
    "peopleNew": "New this week",
    "peopleDisabled": "Disabled",
    "dau": "Daily active",
    "wau": "Weekly active",
    "mau": "Monthly active",
    "worlds": "Worlds",
    "worldsTotal": "Worlds",
    "worldsPublished": "Published",
    "worldsNew": "New this week",
    "rooms": "Rooms",
    "liveInstances": "Live rooms",
    "occupantsNow": "People in rooms",
    "visits24h": "Visits today",
    "medianSession": "Median session",
    "assets": "Assets",
    "storage": "Storage",
    "storageUsed": "Stored",
    "social": "Social",
    "friendships": "Friendships",
    "messages24h": "Messages today",
    "worldChat24h": "World chat today",
    "moderationToday": "Moderation today",
    "activeRestrictions": "Live restrictions",
    "trendChart": "Activity",
    "topWorlds": "Busiest worlds",
    "topWorldsEmpty": "No world has been visited yet.",
    "storageByType": "Storage by type",
    "needsAttention": "Needs attention",
    "attentionFailedJobs_one": "{{count}} asset failed to process",
    "attentionFailedJobs_other": "{{count}} assets failed to process",
    "attentionOrphaned_one": "{{count}} orphaned file taking {{size}}",
    "attentionOrphaned_other": "{{count}} orphaned files taking {{size}}",
    "attentionNoFeatured": "No world is featured, so the home banner is empty",
    "attentionAllClear": "Nothing needs attention."
  },
  "metric": {
    "signups": "Sign-ups",
    "logins": "Sign-ins",
    "visits": "Room visits",
    "worlds_created": "Worlds created",
    "assets_uploaded": "Assets uploaded",
    "messages": "Messages",
    "moderation_actions": "Moderation actions"
  },
  "range": {
    "label": "Range",
    "7d": "7 days",
    "30d": "30 days",
    "90d": "90 days",
    "365d": "12 months"
  },
  "users": {
    "title": "People",
    "subtitle": "Every account on the platform.",
    "searchPlaceholder": "Search by name or email…",
    "status": "Status",
    "statusAll": "All",
    "statusActive": "Active",
    "statusDisabled": "Disabled",
    "statusDeleted": "Deleted",
    "group": "Group",
    "columnPerson": "Person",
    "columnStatus": "Status",
    "columnGroups": "Groups",
    "columnWorlds": "Worlds",
    "columnStorage": "Storage",
    "columnJoined": "Joined",
    "columnLastSeen": "Last seen",
    "badgeDisabled": "Disabled",
    "badgeDeleted": "Deleted",
    "badgeActive": "Active",
    "empty": "No accounts yet.",
    "detailTitle": "Account",
    "tabOverview": "Overview",
    "tabSessions": "Devices",
    "tabGroups": "Groups",
    "tabLimits": "Limits",
    "tabWorlds": "Worlds",
    "tabModeration": "Moderation",
    "tabActivity": "Sign-in history",
    "identities": "Sign-in methods",
    "identityLinked": "Linked {{date}}",
    "sessions": "Signed-in devices",
    "sessionsEmpty": "No live sessions.",
    "sessionCurrent": "This device",
    "revokeSession": "Sign out this device",
    "revokeAll": "Sign out everywhere",
    "revokeAllConfirm": "Sign out every device?",
    "revokeAllBody": "{{name}} will have to sign in again on every device. Nothing else changes.",
    "disable": "Disable account",
    "enable": "Enable account",
    "disableConfirm": "Disable this account?",
    "disableBody": "{{name}} will be signed out everywhere and will not be able to sign in again until you enable the account. Their worlds and assets are kept.",
    "disableReason": "Reason (recorded in the audit log)",
    "enableConfirm": "Enable this account?",
    "enableBody": "{{name}} will be able to sign in again.",
    "deleteAccount": "Delete account",
    "deleteConfirm": "Delete this account?",
    "deleteBody": "{{name}} will be signed out and removed from the platform. This is a soft delete — the data stays and can be restored by an engineer — but the person loses access immediately.",
    "cannotDisableSelf": "You cannot disable your own account.",
    "cannotDeleteSelf": "You cannot delete your own account.",
    "addToGroup": "Add to a group",
    "removeFromGroup": "Remove from {{group}}",
    "removeFromGroupConfirm": "Remove from {{group}}?",
    "removeFromGroupBody": "{{name}} loses every permission that group carries.",
    "noGroups": "Not in any group.",
    "recentLogins": "Recent sign-ins",
    "loginSuccess": "Signed in",
    "loginFailed": "Failed",
    "noLogins": "No sign-in recorded.",
    "moderationAgainst": "Actions taken against this account",
    "noModeration": "Nothing has been recorded against this account.",
    "ownedWorlds": "Worlds owned",
    "noWorlds": "This account owns no worlds.",
    "storageBreakdown": "Storage used",
    "disabled": "Account disabled",
    "enabled": "Account enabled",
    "deleted": "Account deleted",
    "sessionRevoked": "Device signed out",
    "allSessionsRevoked": "Signed out everywhere",
    "groupAdded": "Added to the group",
    "groupRemoved": "Removed from the group",
    "addToGroupAction": "Add to group",
    "tabAnalytics": "Analytics"
  },
  "worlds": {
    "title": "Worlds",
    "subtitle": "Every world, at any status or privacy.",
    "searchPlaceholder": "Search worlds…",
    "status": "Status",
    "privacy": "Privacy",
    "category": "Category",
    "featuredOnly": "Featured only",
    "columnWorld": "World",
    "columnOwner": "Owner",
    "columnStatus": "Status",
    "columnPrivacy": "Privacy",
    "columnActive": "Now",
    "columnVisits": "Visits",
    "columnRating": "Rating",
    "columnCreated": "Created",
    "statusDRAFT": "Draft",
    "statusPUBLISHED": "Published",
    "statusARCHIVED": "Archived",
    "privacyPUBLIC": "Public",
    "privacyPRIVATE": "Private",
    "privacyCODE": "Code",
    "badgeFeatured": "Featured",
    "badgeDeleted": "Deleted",
    "empty": "No worlds yet.",
    "detailTitle": "World",
    "tabOverview": "Overview",
    "tabInstances": "Instances",
    "tabVisits": "Visits",
    "tabGroups": "Groups",
    "tabModeration": "Moderation",
    "feature": "Feature on the home screen",
    "unfeature": "Remove from the home screen",
    "featured": "Featured",
    "featuredHint": "Featured worlds appear in the banner on the home screen, in the order below.",
    "featuredEmpty": "No world is featured. The home banner is empty.",
    "featuredOrder": "Banner order",
    "featuredReorder": "Drag to reorder the banner",
    "featureSaved": "The home banner was updated.",
    "sceneObjects": "Objects placed",
    "instances": "Instances",
    "uniqueVisitors": "Unique visitors",
    "ratingBreakdown": "Ratings",
    "noRatings": "Not rated yet.",
    "noInstances": "No instances.",
    "noVisits": "Nobody has visited yet.",
    "deleteWorld": "Delete world",
    "deleteConfirm": "Delete this world?",
    "deleteBody": "{{title}} disappears from discovery and nobody can enter it. This is a soft delete and can be undone.",
    "restore": "Restore world",
    "restoreConfirm": "Restore this world?",
    "restoreBody": "{{title}} becomes visible again at its previous status.",
    "restored": "World restored",
    "deleted": "World deleted",
    "updated": "World updated",
    "editTitle": "Edit world",
    "fieldTitle": "Title",
    "fieldDescription": "Description",
    "fieldCategory": "Category",
    "fieldPrivacy": "Privacy",
    "fieldStatus": "Status",
    "privacyINVITE": "Invite only"
  },
  "assets": {
    "title": "Assets",
    "subtitle": "Every file uploaded to the platform.",
    "searchPlaceholder": "Search assets…",
    "type": "Type",
    "visibility": "Visibility",
    "columnAsset": "Asset",
    "columnType": "Type",
    "columnOwner": "Owner",
    "columnVisibility": "Visibility",
    "columnSize": "Size",
    "columnStatus": "Status",
    "columnUploaded": "Uploaded",
    "typeIMAGE": "Image",
    "typeVIDEO": "Video",
    "typeDOCUMENT": "Document",
    "typeAUDIO": "Audio",
    "typeSKYBOX": "Skybox",
    "visibilityPRIVATE": "Private",
    "visibilityPUBLIC": "Public",
    "visibilityPAID": "Paid",
    "platformOwned": "Platform",
    "empty": "No assets yet.",
    "detailTitle": "Asset",
    "reprocess": "Run processing again",
    "reprocessQueued": "Queued. The file is being processed again.",
    "uploadTitle": "Upload to the platform library",
    "uploadHint": "Platform assets are owned by nobody and are available to everyone.",
    "uploadType": "Kind of asset",
    "uploadTypePrompt": "Choose a kind…",
    "renderingPreview": "Drawing a preview…",
    "uploadName": "Name",
    "uploadCategory": "Folder",
    "uploadDrop": "Drop a file here, or choose one",
    "uploading": "Uploading…",
    "uploaded": "Uploaded",
    "deleteConfirm": "Delete this asset?",
    "deleteBody": "{{name}} is removed from the library. Any world using it loses it.",
    "deleted": "Asset deleted",
    "updated": "Asset updated",
    "jobsTitle": "Processing queue",
    "jobsSubtitle": "Uploads waiting to be converted, and the ones that failed.",
    "jobStatus": "Status",
    "jobAttempts": "Attempts",
    "jobError": "Error",
    "retryJob": "Retry",
    "retried": "Queued again",
    "reconcile": "Repair stuck uploads",
    "reconcileConfirm": "Repair stuck uploads?",
    "reconcileBody": "Every asset with no processing job will be queued. This is safe to run at any time.",
    "reconciled_one": "Queued {{count}} stuck upload.",
    "reconciled_other": "Queued {{count}} stuck uploads.",
    "reconciledNone": "Nothing was stuck.",
    "noJobsPending": "The queue is empty.",
    "typeMODEL_3D": "3D model",
    "typeIMAGE_360": "360 image",
    "typeVIDEO_360": "360 video",
    "clickToPreview": "Click to preview",
    "previewFailed": "This file could not be displayed. It may still be processing, or the stored copy may be damaged.",
    "noPreview": "No preview is available for this kind of file.",
    "pdfNoInlineViewer": "This browser will not display a PDF inline. Open it in a new tab instead.",
    "loadingViewer": "Loading the 3D viewer…",
    "downloadOriginal": "Download",
    "originalFilename": "Original file",
    "contentType": "Format",
    "usages": "Used as",
    "noThumbnail": "No thumbnail",
    "loadingModel": "Loading the model…",
    "background": "Background",
    "backgroundNormal": "Normal",
    "backgroundLight": "Light",
    "backgroundDark": "Dark",
    "regenerateThumbnail": "Regenerate thumbnail",
    "thumbnailSaved": "Preview saved.",
    "modelVersion": "Which version",
    "versionOptimised": "Optimised",
    "versionOriginal": "Original",
    "wireframe": "Wireframe",
    "autoRotate": "Spin",
    "vertices": "Vertices",
    "triangles": "Triangles",
    "meshes": "Meshes",
    "materials": "Materials",
    "dimensions": "Size (m)",
    "animations": "Animations",
    "lodLevels": "Detail levels",
    "rigged": "Rigged"
  },
  "avatars": {
    "title": "Avatars",
    "subtitle": "The avatar catalog everyone chooses from.",
    "searchPlaceholder": "Search avatars…",
    "category": "Category",
    "columnAvatar": "Avatar",
    "columnCategory": "Category",
    "columnOrder": "Order",
    "columnStatus": "Status",
    "badgeActive": "Active",
    "badgeInactive": "Hidden",
    "badgePremium": "Premium",
    "empty": "The catalog is empty. Upload an avatar to get started.",
    "add": "Add an avatar",
    "addTitle": "Add an avatar to the catalog",
    "editTitle": "Edit avatar",
    "fieldName": "Name",
    "fieldCategory": "Category",
    "fieldOrder": "Sort order",
    "fieldActive": "Visible in the catalog",
    "fieldPremium": "Premium",
    "fieldModel": "Model (.glb)",
    "fieldThumbnail": "Thumbnail",
    "modelHint": "A GLB file. It is validated and optimised the same way a player's upload is.",
    "thumbnailHint": "Optional. A square image works best.",
    "created": "Avatar added",
    "updated": "Avatar updated",
    "deleted": "Avatar removed",
    "deleteConfirm": "Remove this avatar?",
    "deleteBody": "{{name}} disappears from the catalog. If anybody is wearing it the server will refuse — hide it instead, from the row menu.",
    "categories": "Categories",
    "categoriesTitle": "Avatar categories",
    "addCategory": "Add a category",
    "categoryKey": "Key",
    "categoryName": "Name",
    "categoryDeleteConfirm": "Delete this category?",
    "categoryDeleteBody": "{{name}} is removed. Avatars in it become uncategorised.",
    "categoryNotEmpty": "{{name}} still holds {{count}} avatars. Move them first.",
    "categoryCreated": "Category added",
    "categoryDeleted": "Category deleted",
    "columnDefault": "Default",
    "badgeDefault": "Default",
    "hiddenHint": "Hidden avatars stay with whoever already wears them; nobody new can choose one.",
    "deleteRefused": "That avatar could not be removed",
    "takeThumbnail": "Take thumbnail",
    "focusFace": "Focus face",
    "noHeadBone": "No head bone in this rig, so the view was left as it is.",
    "picture": "Gallery picture",
    "pictureHint": "Shown in the avatar picker. A square image works best.",
    "uploadPicture": "Upload a picture",
    "showModel": "Show the model",
    "hideModel": "Hide the model",
    "noModel": "This avatar has no model stored, so there is nothing to render.",
    "capturedPreview": "Captured from the model. Nothing is saved until you accept it.",
    "useThisThumbnail": "Use this picture",
    "thumbnailUpdated": "Gallery picture updated",
    "noPicture": "No picture"
  },
  "categories": {
    "title": "World categories",
    "subtitle": "The filter chips people browse worlds by.",
    "add": "Add a category",
    "key": "Key",
    "name": "Name",
    "active": "Visible",
    "worlds": "Worlds",
    "empty": "No categories yet.",
    "created": "Category added",
    "updated": "Category updated",
    "deleted": "Category deleted",
    "deleteConfirm": "Delete this category?",
    "deleteBody": "{{name}} is removed from the filter chips.",
    "notEmpty": "{{name}} still holds {{count}} worlds. Move them first.",
    "keyHint": "Lowercase, no spaces. It cannot be changed later."
  },
  "groups": {
    "title": "Groups & permissions",
    "subtitle": "What each group of people is allowed to do.",
    "platformGroups": "Platform groups",
    "add": "Create a group",
    "createTitle": "Create a group",
    "editTitle": "Edit group",
    "fieldName": "Name",
    "fieldDescription": "Description",
    "fieldColor": "Colour",
    "badgeSystem": "Built in",
    "systemHint": "Built-in groups cannot be renamed or deleted, but what they carry can be changed.",
    "empty": "No groups yet.",
    "permissions": "Permissions",
    "permissionsHeld_one": "{{count}} of {{total}}",
    "permissionsHeld_other": "{{count}} of {{total}}",
    "planGated": "Plan",
    "members": "Members",
    "addMember": "Add somebody",
    "pickerNoMatches": "No account matches that.",
    "alreadyMember": "Already in",
    "addMemberPlaceholder": "Search by name or email…",
    "removeMember": "Remove",
    "removeMemberConfirm": "Remove {{name}} from {{group}}?",
    "removeMemberBody": "They lose every permission this group carries.",
    "noMembers": "Nobody is in this group.",
    "created": "Group created",
    "updated": "Group updated",
    "deleted": "Group deleted",
    "memberAdded": "Added to the group",
    "memberRemoved": "Removed from the group",
    "deleteConfirm": "Delete this group?",
    "deleteBody": "{{name}} is removed and its {{count}} members lose every permission it carried.",
    "memberNotFound": "No account with the address {{email}}.",
    "impliedByWildcard": "Covered by the wildcard this group holds"
  },
  "flags": {
    "title": "Feature flags",
    "subtitle": "Switch parts of the product on and off, for everyone or for a few.",
    "columnState": "State",
    "on": "On",
    "off": "Off",
    "badgeSystem": "Required",
    "systemHint": "The platform depends on this feature; it cannot be switched off.",
    "categoryOn": "Everything in {{name}} is on",
    "categoryOff": "Everything in {{name}} is off",
    "overrides": "Exceptions",
    "overridesHint": "An exception overrides the switch above for one group or one person — which is what a staged rollout looks like from the inside.",
    "addOverride": "Add an exception",
    "overrideForGroup": "For a group",
    "overrideForUser": "For one person",
    "overrideEnabled": "On for them",
    "overrideDisabled": "Off for them",
    "removeOverride": "Remove",
    "noOverrides": "No exceptions. Everybody follows the switch.",
    "empty": "No feature flags.",
    "updated": "Feature updated",
    "overrideAdded": "Exception added",
    "overrideRemoved": "Exception removed",
    "toggleConfirm": "Switch {{name}} off?",
    "toggleBody": "Everybody loses this feature immediately, including people already in a room.",
    "search": "Search features…",
    "turnAllOff": "Turn all off",
    "turnAllOn": "Turn all on"
  },
  "parameters": {
    "title": "Limits",
    "subtitle": "How much each plan and each account is allowed.",
    "columnLimit": "Limit",
    "columnDefault": "Default",
    "columnGroups": "By group",
    "unlimited": "Unlimited",
    "notSet": "Default",
    "setForGroup": "Set for a group",
    "clearForGroup": "Use the default",
    "empty": "No limits are defined.",
    "updated": "Limit updated",
    "cleared": "Limit cleared",
    "valueLabel": "Value",
    "valueHint": "Leave empty to go back to the default.",
    "editFor": "{{limit}} for {{group}}",
    "accountOverride": "Set just for this account",
    "accountOverrideHint": "Overrides whatever their groups give them.",
    "sourceAccount": "Set on the account",
    "sourceRole": "From {{name}}",
    "sourceDefault": "Default",
    "emptyHint": "Limits are seeded from the code catalogue. If this is empty, the database has not been seeded — run the backend’s db:seed.",
    "tableHint": "Every cell is editable. A limit left on “Default” follows the platform default; setting one on a group overrides it for everybody in that group.",
    "valueInUnit": "Value ({{unit}})"
  },
  "moderation": {
    "title": "Moderation",
    "subtitle": "What has been done across every world.",
    "tabActions": "History",
    "tabRestrictions": "Live restrictions",
    "type": "Action",
    "columnWhen": "When",
    "columnAction": "Action",
    "columnPerson": "Person",
    "columnWorld": "World",
    "columnModerator": "Moderator",
    "columnReason": "Reason",
    "columnExpires": "Until",
    "permanent": "Permanent",
    "empty": "Nothing has been recorded.",
    "emptyRestrictions": "No restriction is in force anywhere.",
    "lift": "Lift",
    "liftConfirm": "Lift this restriction?",
    "liftBody": "{{name}} is no longer {{restriction}} in {{world}}.",
    "lifted": "Restriction lifted",
    "typeMUTE": "Muted",
    "typeUNMUTE": "Unmuted",
    "typeCHAT_MUTE": "Chat muted",
    "typeCHAT_UNMUTE": "Chat unmuted",
    "typeKICK": "Removed",
    "typeBAN": "Banned",
    "typeUNBAN": "Unbanned",
    "typeFREEZE": "Frozen",
    "typeUNFREEZE": "Unfrozen",
    "typeTELEPORT": "Teleported",
    "typeVOICE_SCOPE": "Voice moved",
    "typeMUTE_ALL": "Muted everybody",
    "typeUNMUTE_ALL": "Unmuted everybody",
    "everybody": "Everybody in the room",
    "platformWide": "Platform-wide"
  },
  "system": {
    "title": "System",
    "subtitle": "Whether the pieces are running.",
    "database": "Database",
    "redis": "Redis",
    "worker": "Worker",
    "queue": "Queue",
    "healthy": "Healthy",
    "degraded": "Degraded",
    "down": "Down",
    "latency": "{{ms}} ms",
    "lastSeen": "Last seen {{when}}",
    "queuePending": "Waiting",
    "queueProcessing": "Running",
    "queueFailed": "Failed",
    "version": "Version",
    "nodeVersion": "Node",
    "uptime": "Uptime",
    "environment": "Environment",
    "notReporting": "Not reporting",
    "noHeartbeatConfigured": "No heartbeat configured (WORKER_HEARTBEAT_PATH), so its state is unknown rather than bad.",
    "serving": "Serving {{queues}}"
  },
  "audit": {
    "title": "Audit log",
    "subtitle": "Every change made from this panel.",
    "columnWhen": "When",
    "columnWho": "Who",
    "columnWhat": "What",
    "columnResource": "On",
    "empty": "Nothing has been changed yet.",
    "from": "From",
    "to": "To"
  },
  "a11y": {
    "mainNavigation": "Main navigation",
    "chartDescription": "{{metric}} between {{from}} and {{to}}"
  },
  "site": {
    "title": "Marketing site",
    "description": "What the public website shows, and in what order.",
    "sectionsTitle": "Home page sections",
    "sectionsDescription": "Turn a section off to hide it from visitors, or move it to change where it appears. The website owns the list; you decide what it shows.",
    "sectionsSaved": "Layout saved",
    "sectionsSaveFailed": "Could not save the layout",
    "unsavedHint": "These changes are not live until you save.",
    "visible": "Visible",
    "moveUp": "Move {{name}} up",
    "moveDown": "Move {{name}} down",
    "sections": {
      "worlds": "Live worlds",
      "make": "Block scripting",
      "save": "The save rule",
      "platforms": "Where it runs",
      "sponsors": "Sponsors",
      "pricing": "Pricing",
      "cta": "Closing call to action"
    },
    "sponsorsTitle": "Sponsors",
    "sponsorsDescription": "The logos in the strip on the home page. Hidden sponsors keep their place in the order.",
    "addSponsor": "Add sponsor",
    "editSponsor": "Edit sponsor",
    "sponsorName": "Name",
    "sponsorLink": "Link",
    "sponsorLinkInvalid": "Must start with http:// or https://",
    "sponsorCreated": "Sponsor added",
    "sponsorDeleted": "Sponsor removed",
    "sponsorSaveFailed": "Could not save the sponsor",
    "sponsorDeleteFailed": "Could not remove the sponsor",
    "deleteSponsorTitle": "Remove this sponsor?",
    "deleteSponsorBody": "{{name}} will stop appearing on the website. This cannot be undone.",
    "noSponsors": "No sponsors yet",
    "noSponsorsHint": "The website shows placeholder marks until you add real ones.",
    "noLogo": "No logo",
    "logoUploadHint": "Save the sponsor first, then click its square in the list to upload a logo.",
    "logoUploaded": "Logo updated",
    "logoFailed": "Could not update the logo",
    "replaceLogo": "Upload a logo for {{name}}",
    "removeLogo": "Remove logo"
  },
  "legal": {
    "title": "Legal documents",
    "description": "The privacy policy and the terms of service. Publishing a version can stop every user until they have read it again.",
    "termsOfService": "Terms of Service",
    "privacyPolicy": "Privacy Policy",
    "unknownDocument": "The server has a document this panel does not know how to draw.",
    "live": "Live",
    "scheduled": "Scheduled",
    "nothingPublished": "Nothing published",
    "nothingPublishedHint": "Write the document below and publish it. Until then there is nothing for anybody to accept.",
    "versionNumber": "Version {{version}}",
    "editorTitle": "The document",
    "editorDescription": "Markdown. The preview beside it is the document as it renders — the same text the website and the app show.",
    "documentTitle": "Title",
    "bodyLabel": "Body (Markdown)",
    "preview": "Preview",
    "saveDraft": "Save draft",
    "draftSaved": "Draft saved. Nobody sees it until you publish.",
    "draftSaveFailed": "The draft could not be saved.",
    "unsaved": "Unsaved changes",
    "sourceDraft": "Draft",
    "sourcePublished": "Live text",
    "sourceEmpty": "Empty",
    "publish": "Publish",
    "publishTitle": "Publish version {{version}}",
    "publishDescription": "This writes a permanent version. It cannot be edited afterwards — a correction is another version.",
    "publishConfirm": "Publish",
    "published": "Published. Nobody was interrupted.",
    "publishedAndAsking": "Published. Everybody will be asked to accept it again.",
    "publishFailed": "The version could not be published.",
    "requiresReacceptance": "Material change — ask everybody again",
    "requiresReacceptanceOn": "Every user is stopped at their next sign-in and must read and accept this version before they can carry on.",
    "requiresReacceptanceOff": "Nobody is interrupted. Use this for a typo, a broken link, or anything that does not change what people agreed to.",
    "effectiveAt": "In force from",
    "effectiveAtHint": "Leave empty to publish now. A future date stores the version and serves it to nobody until then.",
    "englishFirst": "English has to be published first. It is the version every other language falls back to.",
    "historyTitle": "Every version",
    "historyDescription": "{{count}} published. Nothing here is ever edited or deleted — it is the record of what people agreed to.",
    "historyEmpty": "No versions yet",
    "historyEmptyDescription": "The first publish creates version 1.",
    "reasked": "Everybody re-asked",
    "quietChange": "Quiet change",
    "unknownPublisher": "Unknown",
    "column": {
      "version": "Version",
      "status": "Status",
      "effective": "In force from",
      "publishedBy": "Published by",
      "locales": "Languages"
    },
    "language": "Language",
    "languagePublished": "published",
    "languageDrafted": "draft",
    "languageMissing": "not written"
  },
  "analytics": {
    "title": "Analytics",
    "description": "The deeper views. The dashboard is the summary; this is where the questions behind it are answered.",
    "range": "Range",
    "tab": {
      "worlds": "Worlds",
      "content": "Content",
      "operations": "Operations",
      "growth": "Growth",
      "users": "Users",
      "acquisition": "Acquisition"
    },
    "worlds": {
      "title": "World leaderboard",
      "description": "Every world at any status and privacy. Soft-deleted worlds are excluded.",
      "rankBy": "Rank by",
      "rank": {
        "visits": "Visits",
        "rating": "Rating",
        "active": "People in them now"
      },
      "world": "World",
      "owner": "Owner",
      "visits": "Visits",
      "visitors": "People",
      "rating": "Rating",
      "ratingValue": "{{value}} ({{count}})",
      "unrated": "Not rated",
      "activeNow": "In now",
      "featured": "Featured",
      "emptyTitle": "No worlds yet",
      "emptyDescription": "Worlds appear here as soon as the first one is created."
    },
    "content": {
      "totalStored": "Stored",
      "orphaned": "Orphaned",
      "byOwner": "Largest accounts",
      "byOwnerDescription": "The twenty holding the most, by bytes. A platform total says something moved; this says who to talk to.",
      "ownerFigure": "{{size}} · {{count}}",
      "emptyTitle": "Nothing stored yet",
      "emptyDescription": "Accounts appear here once somebody uploads something.",
      "orphanedCount_one": "{{count}} object",
      "orphanedCount_other": "{{count}} objects"
    },
    "operations": {
      "actions": "Moderation actions",
      "kinds": "Kinds of action",
      "byType": "Actions by type",
      "byTypeDescription": "The breakdown is the point rather than the total: fifty mutes and fifty bans are the same number and two very different weeks.",
      "emptyTitle": "No moderation in this range",
      "emptyDescription": "Nothing was actioned in the period selected. Try a wider range."
    },
    "growth": {
      "dau": "Active today",
      "wau": "Active this week",
      "mau": "Active this month",
      "stickiness": "Stickiness",
      "stickinessHint": "Daily active ÷ monthly active",
      "funnel": "From signing up to coming back",
      "funnelDescription": "Where new accounts stop. A total says the platform is growing; this says which step is losing people, which is the version anybody can act on.",
      "step": {
        "signedUp": "Signed up",
        "signedIn": "Signed in",
        "enteredAWorld": "Entered a world",
        "returned": "Came back"
      },
      "peak": "Busiest moment: {{users}} at once, {{when}}.",
      "verified": "Verified email",
      "verifiedHint": "Not a step — sign-in does not require it"
    },
    "users": {
      "signIns": "Sign-ins",
      "accounts": "Accounts",
      "perAccount": "Sign-ins per account",
      "medianSession": "Typical time in a world",
      "composition": "Who they are",
      "compositionDescription": "Counts are events, not people — a headcount per value over several days cannot be worked out from a daily rollup without counting somebody twice. The peak daily figure beside each is a lower bound on the headcount.",
      "breakBy": "Break down by",
      "dimension": {
        "country": "Country",
        "platform": "Platform",
        "deviceClass": "Device",
        "locale": "Language"
      },
      "rowFigure": "{{events}} events · peak {{peak}}/day",
      "clipped": "Showing {{shown}} of {{total}}",
      "emptyTitle": "Nothing recorded yet",
      "emptyDescription": "Values appear here once the client has sent events for this period."
    },
    "acquisition": {
      "signups": "Signups",
      "activated": "Activated",
      "activatedHint": "Entered a world at least once",
      "retained": "Kept a week",
      "retainedHint": "Last seen 7+ days after signing up",
      "measured": "Attributed",
      "measuredHint": "Share of signups whose source is known",
      "bySource": "Where they came from",
      "bySourceDescription": "Signups grouped by the attribution recorded at account creation. Accounts that carried none are listed as unattributed rather than folded into a source nobody claimed.",
      "methodOnly": "This deployment records no signup attribution, so every account below is in the unattributed bucket and no source can be compared against another.",
      "unattributed": "Unattributed",
      "emptyTitle": "Nobody signed up in this period",
      "emptyDescription": "Widen the range, or check back once there are new accounts.",
      "activatedRate": "{{percent}}% activated ({{count}})",
      "keptRate": "{{percent}}% kept ({{count}})",
      "byMethod": "How they signed up",
      "byMethodDescription": "The same accounts, split by the door they came through rather than by where they heard about it.",
      "method": {
        "password": "Email and password",
        "google": "Google Sign-In"
      },
      "methodFigure": "{{signups}} · {{activated}}% activated · {{retained}}% kept"
    },
    "user": {
      "visits": "World visits",
      "visitsHint": "across {{worlds}} worlds",
      "timeInWorlds": "Time in worlds",
      "signIns": "Sign-ins",
      "lastActive": "Last active",
      "whatTheyMade": "What they made",
      "worldsCreated": "Worlds created",
      "worldsCreatedValue": "{{created}} ({{published}} published)",
      "assetsUploaded": "Assets uploaded",
      "storageUsed": "Storage used",
      "quizzesAuthored": "Quizzes authored",
      "scriptsAuthored": "Scripts authored",
      "howTheyBehave": "How they behave",
      "friends": "Friends",
      "messagesSent": "Direct messages",
      "actionsAgainst": "Moderation against them",
      "actionsTaken": "Moderation they took",
      "restrictions": "Active restrictions",
      "consent": "Behavioural analytics",
      "consentGranted": "Agreed",
      "consentDeclined": "Declined",
      "consentNeverAsked": "Never asked",
      "whereTheyGo": "Where they spend their time",
      "whereTheyGoDescription": "The worlds this account visits most, by time spent rather than by number of visits.",
      "worldFigure": "{{visits}} visits · {{time}}",
      "noWorldsTitle": "This account has not entered a world",
      "noWorldsDescription": "Nothing to rank until they do.",
      "worldChat": "World chat"
    },
    "health": {
      "requests": "Requests",
      "requestsOff": "Instrumentation is off",
      "inRange": "In this period",
      "serverErrors": "Server errors",
      "ofRequests": "of requests",
      "latency": "Slowest 5% of requests",
      "median": "median {{ms}} ms",
      "rollup": "Rollup last ran",
      "rollupHint": "Every figure here is as fresh as this",
      "queues": "Queues and ingest",
      "assetsQueued": "Assets queued",
      "assetsRunning": "Assets processing",
      "assetsFailed": "Assets failed",
      "exportsPending": "Exports pending",
      "exportsFailed": "Exports failed",
      "eventsIngested": "Events ingested",
      "samplesIngested": "Spatial samples ingested",
      "clients": "What clients report",
      "sessions": "World sessions",
      "clientErrors": "Client errors",
      "errorsValue": "{{errors}} ({{fatal}} fatal)",
      "abandonRate": "Left before the world loaded",
      "fps": "Frame rate",
      "fpsValue": "{{average}} avg · {{worst}} worst 5%",
      "rtt": "Round trip (median)",
      "liveRooms": "Live now",
      "liveRoomsValue": "{{rooms}} rooms · {{people}} people",
      "stored": "Stored",
      "busiestRoutes": "Busiest routes",
      "busiestRoutesDescription": "By request count. The route TEMPLATE, never the resolved path — a path carries ids, and this table is not a place to keep them.",
      "cost": "Estimated cost",
      "costDescription": "From the prices configured on this deployment. Absent entirely when none are set: a cost built on a guessed price is worse than no cost, because somebody plans against it.",
      "costStorage": "Media storage / month",
      "costDatabase": "Database / month",
      "costRequests": "Requests this period",
      "routeServerErrors": "{{count}} 5xx ({{percent}}%)",
      "routeClientErrors": "{{count}} 4xx"
    },
    "export": {
      "format": "Format",
      "action": "Export",
      "working": "Preparing…",
      "ready": "Your export has downloaded.",
      "failed": "That export could not be produced. Try again, or a narrower range."
    },
    "retention": {
      "title": "Do they stay?",
      "description": "Each row is everybody who arrived on one day, and how many of them were still coming back later. A growth chart cannot tell you whether you are filling a bucket with a hole in it; this can.",
      "cohort": "Arrived",
      "size": "People",
      "emptyTitle": "No cohorts in this period",
      "emptyDescription": "Cohorts appear once accounts have had time to come back — widen the range.",
      "day": "D{{n}}"
    }
  },
  "releases": {
    "title": "App releases",
    "description": "Which build each platform is on, where to get a newer one, and where its Addressables content lives.",
    "gateTitle": "Version gate",
    "gateDescription": "Every installed client asks this before it will run. A build below the minimum is stopped with a link to the store; a build below the latest is offered the update once and may decline.",
    "notGated": "Not version-gated",
    "enabled": "Gate enabled",
    "latestVersion": "Latest version",
    "latestVersionHint": "The newest published build. Anything older is offered the update.",
    "minimumVersion": "Minimum version",
    "minimumVersionHint": "The oldest build still allowed to run. Anything older is stopped.",
    "versionInvalid": "Use MAJOR.MINOR.PATCH, digits only — for example 1.4.2.",
    "minimumAboveLatest": "The minimum cannot be above the latest — that would stop every client, including the one you are about to ship.",
    "storeKind": "Store",
    "storeUrl": "Store link",
    "storeUrlHint": "Where the update button sends somebody. An absolute https:// URL.",
    "releaseNotesUrl": "Release notes link",
    "releaseNotesUrlHint": "Optional. Shown as “What’s new” beside the update button.",
    "contentBaseUrl": "Content base URL",
    "contentBaseUrlHint": "Optional. Leave empty to serve content from this backend. Set it to move content to a CDN without rebuilding any installed app.",
    "webExplainer": "The web build is served rather than installed, so it is always the newest version and is never sent to a store. It still downloads its Addressables content like every other platform.",
    "unsavedHint": "These changes are not live until you save.",
    "saved": "{{platform}} saved",
    "saveFailed": "Could not save this platform",
    "platform": {
      "windows": "Windows",
      "macos": "macOS",
      "android": "Android",
      "quest": "Meta Quest",
      "ios": "iOS",
      "webgl": "Web"
    },
    "store": {
      "appStore": "App Store",
      "googlePlay": "Google Play",
      "metaQuest": "Meta Horizon Store",
      "steam": "Steam",
      "microsoftStore": "Microsoft Store",
      "macAppStore": "Mac App Store",
      "direct": "Direct download",
      "web": "No store (web)"
    },
    "contentTitle": "Content delivery",
    "contentDescription": "Upload the Addressables build for a platform. Package it in Unity with VECOS ▸ Addressables ▸ Package Content For Upload, then drop the zip here.",
    "contentPlatform": "Platform",
    "contentFile": "Content archive (.zip)",
    "contentUpload": "Publish content",
    "contentUploading": "Publishing…",
    "contentUploaded": "Published {{count}} files ({{size}}) to {{platform}}",
    "contentUploadFailed": "Could not publish the content",
    "contentNoFile": "Choose a zip first.",
    "contentWrongType": "That is not a zip. Package the build in Unity first.",
    "contentWarning": "This replaces everything currently published for that platform, at once. Clients already running keep the catalogue they hold until they next launch.",
    "gatesNothing": "Gates nothing",
    "off": "Gate off",
    "unsaved": "Unsaved",
    "webgl": {
      "title": "Web client",
      "description": "The Unity WebGL build the site serves. Uploading stores a build and changes nothing a visitor sees — serving one is what moves the site, and serving an older build is how you roll back.",
      "fileHint": "The folder Unity wrote, zipped at the top level: Build/, StreamingAssets/ if there is one, and the build.json manifest.",
      "upload": "Upload build",
      "uploading": "Uploading…",
      "uploadingHint": "Uploading. A full build is large, so this can take several minutes — leave this tab open.",
      "uploaded_one": "Stored {{version}} — {{count}} file, {{size}}. Nothing is serving it yet.",
      "uploaded_other": "Stored {{version}} — {{count}} files, {{size}}. Nothing is serving it yet.",
      "uploadFailed": "Could not upload that build",
      "wrongType": "That is not a zip. Zip the folder Unity wrote, with build.json at the top level.",
      "column": {
        "version": "Version",
        "uploaded": "Uploaded",
        "files": "Files",
        "size": "Size",
        "servedAt": "Served",
        "action": "Serve"
      },
      "live": "Live",
      "noManifest": "No build.json",
      "cannotServe": "Cannot serve",
      "cannotServeWhy": "No build.json, so the page would not know which files to load. Re-zip from public/play-build after npm run unity:sync.",
      "serve": "Serve",
      "serveNamed": "Serve {{version}}",
      "empty": "No build has been uploaded",
      "emptyDescription": "Nothing is stored here yet, so the site is serving whatever was put on the server by hand — or nothing at all.",
      "retention": "Only the most recent builds are kept: uploading a new one retires the oldest that is not live. The live build is never removed.",
      "confirmTitle": "Serve {{version}}?",
      "confirmBody": "Every visitor who loads the web client from now on gets {{version}} — {{size}}, uploaded {{uploaded}}. Anybody already downloading finishes on the build they started with. Nothing is deleted, and you can serve a different build again at any time.",
      "confirmRollback": "{{version}} was uploaded before the build that is live now, so serving it takes the site back. That is the whole rollback — there is no separate control.",
      "confirmNoManifest": "This build has no build.json. The page reads it to know which filenames Unity wrote, so serving this one leaves visitors with a client that will not load.",
      "confirmAction": "Serve this build",
      "served": "{{version}} is now live",
      "serveFailed": "Could not serve that build",
      "gone": "That build is no longer stored. Uploading a new build retires the oldest one that is not live.",
      "dropTitle": "Choose a build archive, or drop it here",
      "dropHint": "Drag and drop, or click to browse",
      "dropReplace": "click to choose a different one",
      "stored": "Stored builds",
      "serving": {
        "up": "The site is serving {{version}}",
        "upDetail": "Visitors to /play get this build and it loads.",
        "drift": "Serving a build the records disagree about",
        "driftDetail": "The link the edge follows and the build marked live are not the same one.",
        "down": "No client is being served",
        "downNothing": "Nothing has been served yet, so /play tells visitors this server has the site but not the client.",
        "downNoManifest": "The build being served has no build.json, so /play tells visitors this server has the site but not the client.",
        "fixNothing": "Upload a build, then press Serve.",
        "fixNoManifest": "Zip the contents of public/play-build after running",
        "fixDrift": "Serve the build you want again to settle it."
      },
      "uploadedNoManifest": "Stored, but it has no build.json so it cannot be served. Run npm run unity:sync and zip the contents of public/play-build — Build/, StreamingAssets/ and build.json at the top level."
    }
  }
}
